<template lang="pug">
    div(
      :class="[active ? 'drop-zone-active' : '']"
      :data-active="active"
      @drop.prevent="onDrop"
      @dragenter.prevent="setActive"
      @dragover.prevent="setActive"
      @dragleave.prevent="setInactive"
    )
        slot(name="droppableElement" :active="active" :openAttachmentWindow="openAttachmentWindow")
        input.attachment-input(
            type="file"
            ref="inputFile"
            @input="(e) => insertFile(e?.target?.files ? Object.values(e?.target?.files) : [])"
            :accept="acceptFormats"
            tabindex="-1"
            :multiple="true"
          )
</template>

<script>
import { defineComponent, ref, nextTick, getCurrentInstance } from 'vue'
const DropZone = defineComponent({
  props: {
    acceptFormats: {
      type: Array
    }
  },
  setup(props, { emit }) {
    const instance = getCurrentInstance()
    const { $refs } = instance.proxy
    const active = ref(false)

    const setActive = () => {
      active.value = true
    }

    const setInactive = () => {
      active.value = false
    }

    const preventDefaults = (e) => {
      e.preventDefault()
    }
    const onDrop = (e) => {
      preventDefaults(e)
      const files = [...e.dataTransfer.files]
      // Validate file formats
      const output = []
      files.forEach((file) => {
        if (!props?.acceptFormats || props.acceptFormats.includes(file.type))
          output.push(file)
      })
      emit('on-drop', output)
      setInactive()
    }
    const insertFile = (files) => {
      const output = []
      files.forEach((file) => {
        if (!props?.acceptFormats || props.acceptFormats.includes(file.type))
          output.push(file)
      })
      emit('on-drop', output)
      setInactive()
      $refs.inputFile.value = ''
    }
    const openAttachmentWindow = () => {
      nextTick(() => {
        $refs.inputFile?.click()
      })
    }
    return {
      active,
      onDrop,
      setActive,
      setInactive,
      insertFile,
      openAttachmentWindow
    }
  }
})
export default DropZone
</script>
<style lang="sass" scoped>
.attachment-input
  position: absolute
  opacity: 0
  pointer-events: none
</style>
